export type ActivePath =
  | 'projects.ledgers'
  | 'projects.ledgers.home'
  | 'projects.ledgers.entries'
  | 'projects.ledgers.groups'
  | 'projects.ledgers.groups.entries'
  | 'projects.ledgers.groups.balances'
  | 'projects.ledgers.accounts'
  | 'projects.ledgers.accounts.childAccounts'
  | 'projects.ledgers.accounts.lines'
  | 'projects.ledgers.accounts.balances'
  | 'projects.ledgers.accounts.unreconciled'
  | 'projects.ledgers.migrations'
  | 'projects.schema'
  | 'projects'
  | 'links'
  | 'links.accounts'
  | 'links.detail';

// need to account for both schema'd ledgers and unschema'd ledgers in paths

export const createPath = (
  paths: string[],
  createUnschemadPath: boolean
): string[] => {
  if (createUnschemadPath) {
    return [
      ...paths.map((path) => `/projects/schema/:schemaKey/${path}`),
      ...paths.map((path) => `/projects/${path}`),
    ];
  }
  return paths.map((path) => `/projects/schema/:schemaKey/${path}`);
};

export const ACTIVE_PATH_URLS: Record<ActivePath, string[]> = {
  'projects.ledgers': [
    '/projects/schema/:schemaKey/ledgers',
    '/projects/schema/:schemaKey/new-ledger',
    '/projects/ledgers', // no new ledgers for non-schema'd ledgers
  ],
  'projects.ledgers.home': createPath([':ledgerId/home', ':ledgerId'], true),
  'projects.ledgers.entries': createPath(
    [
      ':ledgerId/entries',
      ':ledgerId/entries/:entryId',
      ':ledgerId/entries/:entryId/lines',
      ':ledgerId/entries/:entryId/lines/:lineId',
    ],
    true
  ),
  'projects.ledgers.groups': createPath([':ledgerId/groups'], true),
  'projects.ledgers.groups.entries': createPath(
    [':ledgerId/groups/:groupId/entries'],
    true
  ),
  'projects.ledgers.groups.balances': createPath(
    [':ledgerId/groups/:groupId/balances'],
    true
  ),
  'projects.ledgers.accounts': createPath(
    [':ledgerId/accounts', ':ledgerId/accounts/templates/:templatePath'],
    true
  ),
  'projects.ledgers.accounts.childAccounts': createPath(
    [':ledgerId/accounts/:accountId/childaccounts'],
    true
  ),
  'projects.ledgers.accounts.lines': createPath(
    [
      ':ledgerId/accounts/:accountId/lines',
      ':ledgerId/accounts/:accountId/lines/:lineId',
    ],
    true
  ),
  'projects.ledgers.accounts.balances': createPath(
    [':ledgerId/accounts/:accountId/balances'],
    true
  ),
  'projects.ledgers.accounts.unreconciled': createPath(
    [
      ':ledgerId/accounts/:accountId/unreconciled',
      ':ledgerId/accounts/:accountId/unreconciled/:txId',
    ],
    true
  ),
  'projects.ledgers.migrations': createPath([':ledgerId/migrations'], true),
  'projects.schema': [
    '/projects/schema/:schemaKey',
    '/projects/schema/:schemaKey/scenario/:scenarioId',
  ],
  projects: ['/projects'],
  links: ['/integrations'],
  'links.accounts': [
    '/integrations/links/id/:linkId',
    '/integrations/links/id/:linkId/accounts/:externalAccountId',
    '/integrations/links/id/:linkId/accounts/:externalAccountId/tx/:txId',
  ],
  'links.detail': ['/integrations/links/id/:linkId/details'],
};

export const ALL_ACTIVE_PATHS: ActivePath[] = [
  'projects.ledgers',
  'projects.ledgers.home',
  'projects.ledgers.entries',
  'projects.ledgers.groups',
  'projects.ledgers.groups.entries',
  'projects.ledgers.groups.balances',
  'projects.ledgers.accounts',
  'projects.ledgers.accounts.childAccounts',
  'projects.ledgers.accounts.lines',
  'projects.ledgers.accounts.balances',
  'projects.ledgers.accounts.unreconciled',
  'projects.ledgers.migrations',
  'projects.schema',
  'projects',
  'links',
  'links.accounts',
  'links.detail',
];
